import { Pressable, PressableProps } from 'react-native';
import styles from './styles';
import { Icon } from '@/components/Icon';
import { Text } from '@/components/Text';
import { useOnHover } from '@/hooks/useOnHover';

interface ButtonProps extends PressableProps {
  label?: string;
  onPress: () => void;
  disabled?: boolean;
  look?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'danger'
    | 'warning'
    | 'warningTertiary'
    | 'ghost'
    | 'dangerTertiary';

  icon?: React.ComponentProps<typeof Icon>['name'];
  iconSize?: number;
  iconStyle?: React.ComponentProps<typeof Icon>['style'];
}

export const Button: React.FC<ButtonProps> = ({
  onPress,
  disabled,
  look = 'primary',
  icon,
  iconSize = 20,
  iconStyle,
  label,
  style,
  testID,
}) => {
  const { isHovered, handleHoverIn, handleHoverOut } = useOnHover();

  return (
    <Pressable
      testID={testID}
      onPress={onPress}
      disabled={disabled}
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
      style={({ pressed }) => [
        styles.common,
        style,
        disabled ? styles[`${look}Disabled`] : styles[look],
        isHovered && !disabled ? styles[`${look}Hovered`] : {},
        pressed ? styles[`${look}Pressed`] : {},
      ]}
    >
      {({ pressed }) => (
        <>
          {icon ? (
            <Icon
              name={icon}
              style={{
                ...styles[`${look}Label`],
                ...(isHovered && !disabled
                  ? styles[`${look}LabelHovered`]
                  : null),
                ...(disabled ? styles[`${look}LabelDisabled`] : {}),
                ...(pressed ? styles[`${look}LabelPressed`] : {}),
                ...iconStyle,
              }}
              size={iconSize}
            />
          ) : null}
          {!!label && (
            <Text
              style={[
                styles.commonLabel,
                styles[`${look}Label`],
                isHovered && !disabled ? styles[`${look}LabelHovered`] : {},
                disabled ? styles[`${look}LabelDisabled`] : {},
                pressed ? styles[`${look}LabelPressed`] : {},
                icon && { marginLeft: 12 },
              ]}
            >
              {label}
            </Text>
          )}
        </>
      )}
    </Pressable>
  );
};
